import { createSlice } from "@reduxjs/toolkit";
import { ShellConfig } from "../../models/common.model";

const initialShellConfigState: ShellConfig = {
  comment: "",
  headerTitleColor: "",
  mainheaderTitleColor: "",
  headerTitle: "",
  mainHeaderTitle: "",
  companyName: "",
  sidemenueLogo: "",
  asideMenuColor: "",
  mainColor: "",
  defualtColor: "",
  defualtColor_100: "",
  defualtColor_200: "",
  secondColor: "",
  secondColor_100: "",
  secondColor_200: "",
  secondColor_300: "",
  secondColor_400: "",
  secondColor_500: "",
  secondColorClass: "",
  selectedAsideMenuColor: "",
  favIcon: "",
  loginLogo: "",
  loginTitle: "",
  muiColor: "",
  badgeColor: "",
  muiSelected: "",
  sideMenuLogoCollapsed: "",
};

export const ShellConfigSlice = createSlice({
  name: "shellConfig",
  initialState: initialShellConfigState,
  reducers: {
    setShellConfig: (state, action) => {
      return action.payload;
    },
  },
});

// this is for dispatch
export const { setShellConfig } = ShellConfigSlice.actions;

// this is for configureStore
export default ShellConfigSlice.reducer;
